import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import * as React from 'react';
import { ProjectGq, ProjectGqProps } from '../../models/ProjectGq';

export default function useUpdateProjectLocationGq() {
  const [mutation, mutationResult] = useMutation<GqResponse, GqVariables>(gqTag);

  return React.useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then((result) => result.data.projects.updateProjectLocation.project),
    []
  );
}

const gqTag = gql`
  mutation UpdateProjectLocation($command: UpdateProjectLocationCommand!) {
    projects {
      updateProjectLocation(command: $command) {
        project { ${ProjectGqProps} }
      }
    }
  }
`;

interface GqVariables {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
  locationId?: number;
  locationName?: string;
  rankLocationId: number;
  rankLocationName: string;
}

interface GqResponse {
  projects: {
    updateProjectLocation: {
      project: ProjectGq;
    };
  };
}
